import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const IN_VIEW_LOAD_DELAY = 1.5;

/**
 * Matches ScrollTrigger `start: "top 85%"` / `"top 92%"` (top of trigger vs viewport % from top).
 * Keep in sync with `start` strings below.
 */
function scrollStartAlreadyMet(block, nestedInFlexibleColumns) {
	const pct = nestedInFlexibleColumns ? 0.92 : 0.85;
	const line = window.innerHeight * pct;
	return block.getBoundingClientRect().top <= line;
}

/** ScrollTrigger ignores `delay` on tweens; use timeline start position instead. */
function entrancePosition(block, nestedInFlexibleColumns) {
	return scrollStartAlreadyMet(block, nestedInFlexibleColumns)
		? IN_VIEW_LOAD_DELAY
		: 0;
}

export default class AnimateCards {
	constructor(block) {
		this.block = block;
		this.cards = this.block.querySelectorAll(".animate-card");
		this.animateBlock();
	}

	animateBlock() {
		if (!this.cards.length) {
			return;
		}

		gsap.set(this.cards, {
			opacity: 0,
			y: 64,
		});

		// Nested blocks (e.g. info cards grid in a column) sit higher in the layout; a deep
		// viewport offset makes the trigger feel very late. Percentage starts read predictably.
		const nestedInFlexibleColumns = Boolean(
			this.block.closest(".block-flexible-columns")
		);
		const start = nestedInFlexibleColumns ? "top 92%" : "top 85%";
		const pos = entrancePosition(this.block, nestedInFlexibleColumns);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.block,
				start,
				once: true,
				invalidateOnRefresh: true,
			},
		});

		tl.to(
			this.cards,
			{
				opacity: 1,
				y: 0,
				duration: 0.5,
				stagger: 0.1,
				ease: "power2.out",
			},
			pos
		);
	}
}
